import { UiSchema } from '@rjsf/utils';
import { Prompt, PromptModel } from 'api/model';
import ModelRenderer from 'components/form/CustomRenderers/ModelRenderer';
import ListSelectionWidget from 'components/form/ListSelectionWidget';
import PromptTestCaseInputWidget from 'components/form/PromptTestCaseInputWidget';
import { JSONSchema7 } from 'json-schema';

type ModelOption = {
  const: string;
  title: string;
};

function getFormSchema(fieldsInputs: string[], models?: PromptModel[]): JSONSchema7 {
  const properties = fieldsInputs?.reduce((a, v) => ({ ...a, [v]: { type: 'string' } }), {});

  return {
    type: 'object',
    properties: {
      llm_model_id: {
        title: 'Model',
        type: 'string',
        anyOf: modelSelect(models),
      },
      temperature: {
        type: 'number',
        title: 'Temperature',
        minimum: 0,
        maximum: 2,
        multipleOf: 0.1,
      },
      run_count: {
        type: 'integer',
        title: 'Run count',
        minimum: 1,
        default: 1,
      },
      test_case: {
        type: 'object',
        // title: 'Inputs fields',
        title: '',
        properties: properties,
      },
    },
    required: ['llm_model_id', ...fieldsInputs],
  };
}

function modelSelect(models?: PromptModel[]): ModelOption[] {
  const results: ModelOption[] = [];

  for (const model of models ?? []) {
    results.push({
      const: model.id,
      title: model.name,
    });
  }

  return results;
}

function getUiSchema(prompt?: Prompt, models?: PromptModel[]): UiSchema {
  const uiSchema = {
    test_case: {
      'ui:style': { marginTop: '-1.5rem' },
    },
    llm_model_id: {
      'ui:widget': ListSelectionWidget,
      'ui:options': {
        autocomplete: true,
        render: (modelId: string) => <ModelRenderer modelId={modelId} models={models!} />,
      },
    },
  } as UiSchema;

  for (const input of prompt?.inputs ?? []) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    uiSchema.test_case[input] = {
      'ui:widget': PromptTestCaseInputWidget,
      'ui:options': { promptId: prompt?.id },
    };
  }

  return uiSchema;
}

export { getFormSchema, getUiSchema };
